import React from 'react';
import { XIcon } from 'lucide-react';
interface ImpressumModalProps {
  onClose: () => void;
}
export function ImpressumModal({
  onClose
}: ImpressumModalProps) {
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-91">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto" data-id="element-92">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 sticky top-0 bg-white rounded-t-xl" data-id="element-93">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-94">Impressum</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-95">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-96" />
          </button>
        </div>
        <div className="p-6 space-y-6 text-gray-700 leading-relaxed" data-id="element-97">
          <section data-id="element-98">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-99">
              Angaben gemäß § 5 TMG
            </h3>
            <p data-id="element-100">
              INTIGOO! GmbH
              <br data-id="element-101" />
              Werner-von-Siemens-Straße 33
              <br data-id="element-102" />
              49124 Georgsmarienhütte
            </p>
          </section>

          <section data-id="element-103">
            <p data-id="element-104">
              <strong data-id="element-105">Handelsregister:</strong> HRB 217224
              <br data-id="element-106" />
              <strong data-id="element-107">Registergericht:</strong> Amtsgericht Osnabrück
            </p>
          </section>

          <section data-id="element-108">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-109">
              Vertreten durch
            </h3>
            <p data-id="element-110">
              Fabian Kleine Huxel
              <br data-id="element-111" />
              Felix Höfelmeyer
            </p>
          </section>

          <section data-id="element-112">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-113">Kontakt</h3>
            <p data-id="element-114">
              <strong data-id="element-115">Telefon:</strong> +49 5401 1689580
              <br data-id="element-116" />
              <strong data-id="element-117">E‑Mail:</strong>{' '}
              <a href="mailto:info@intigoo.de" className="text-blue-600 hover:underline" data-id="element-118">
                info@intigoo.de
              </a>
            </p>
          </section>

          <section data-id="element-119">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-120">
              Umsatzsteuer-ID
            </h3>
            <p data-id="element-121">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a
              Umsatzsteuergesetz:
              <br data-id="element-122" />
              DE 349819653
            </p>
          </section>

          <section data-id="element-123">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-124">
              EU-Streitschlichtung
            </h3>
            <p data-id="element-125">
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{' '}
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline break-all" data-id="element-126">
                https://ec.europa.eu/consumers/odr/
              </a>
              .
              <br data-id="element-127" />
              Unsere E‑Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section data-id="element-128">
            <h3 className="font-semibold text-gray-900 mb-2" data-id="element-129">
              Verbraucherstreitbeilegung / Universalschlichtungsstelle
            </h3>
            <p data-id="element-130">
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>
        </div>
      </div>
    </div>;
}